module.exports = __webpack_public_path__ + "static/media/MenuIceCream.2694cbd7.jpg";